/**
 * Cross-option availability (Fase 7B design refresh 2026).
 *
 * Disabilita le option values non disponibili per la combinazione selezionata.
 * Es: prodotto con Color e Size, se "Grey 9 (L)" e' sold out, selezionando
 * Grey la size 9 (L) appare barrata e non cliccabile.
 *
 * Implementazione: event delegation su document. Dawn sostituisce l'intero
 * <variant-selects> al fetch della nuova variante, quindi i listener diretti
 * sull'elemento muoiono. Delegation evita il problema.
 */
(function () {
  'use strict';
  var STYLE_ID = '__variant-availability-cross-option-css';
  if (!document.getElementById(STYLE_ID)) {
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      'input.disabled + label,',
      'label.disabled,',
      '.product-form__input input.disabled + label {',
      '  opacity: 0.4;',
      '  text-decoration: line-through;',
      '  cursor: not-allowed !important;',
      '  pointer-events: none;',
      '}',
      '.product-form__input select option:disabled {',
      '  color: rgba(0,0,0,0.4);',
      '  text-decoration: line-through;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }
  var COLOR_RE = /^(color|colore|colour|farbe|couleur|cor)$/i;
  var DEBUG = true;
  function log() {
    if (!DEBUG) return;
    var args = ['[7B]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }
  log('script loaded');

  function getMatrix(picker) {
    var el = picker.querySelector('script[data-variant-matrix]');
    if (!el) return null;
    try {
      var m = JSON.parse(el.textContent);
      return Array.isArray(m) && m.length ? m : null;
    } catch (e) {
      return null;
    }
  }

  function getSelectedOptionsByPosition(picker) {
    var selected = [];
    picker.querySelectorAll('fieldset.product-form__input').forEach(function (fs) {
      var checked = fs.querySelector('input:checked');
      selected.push(checked ? checked.value : null);
    });
    picker.querySelectorAll('.product-form__input--dropdown select').forEach(function (sel) {
      selected.push(sel.value || null);
    });
    return selected;
  }

  function isAvailable(matrix, posIdx, value, currentSelection) {
    for (var i = 0; i < matrix.length; i++) {
      var v = matrix[i];
      if (!v.a) continue;
      if (v.o[posIdx] !== value) continue;
      var ok = true;
      for (var j = 0; j < currentSelection.length; j++) {
        if (j === posIdx) continue;
        if (currentSelection[j] != null && v.o[j] !== currentSelection[j]) {
          ok = false;
          break;
        }
      }
      if (ok) return true;
    }
    return false;
  }

  function update(picker) {
    var matrix = getMatrix(picker);
    if (!matrix) { log('no matrix in picker', picker); return; }
    var currentSelection = getSelectedOptionsByPosition(picker);
    log('update called. selection:', currentSelection, 'matrix entries:', matrix.length);
    var posIndex = 0;

    picker.querySelectorAll('fieldset.product-form__input').forEach(function (fs) {
      var idx = posIndex++;
      var legend = fs.querySelector('legend.form__label');
      var isColor = !!(legend && COLOR_RE.test(legend.textContent.trim().split(':')[0].trim()));
      fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var available = isColor ? true : isAvailable(matrix, idx, input.value, currentSelection);
        if (available) {
          input.classList.remove('disabled');
          input.removeAttribute('aria-disabled');
        } else {
          input.classList.add('disabled');
          input.setAttribute('aria-disabled', 'true');
        }
        if (input.id) {
          var lbl = picker.querySelector('label[for="' + input.id + '"]');
          if (lbl) {
            if (available) lbl.classList.remove('disabled');
            else lbl.classList.add('disabled');
          }
        }
      });
    });

    picker.querySelectorAll('.product-form__input--dropdown select').forEach(function (sel) {
      var idx = posIndex++;
      var ddWrap = sel.closest('.product-form__input--dropdown');
      var ddLbl = ddWrap ? ddWrap.querySelector('label.form__label') : null;
      var isColorSel = !!(ddLbl && COLOR_RE.test(ddLbl.textContent.trim().split(':')[0].trim()));
      Array.from(sel.options).forEach(function (opt) {
        opt.disabled = isColorSel ? false : !isAvailable(matrix, idx, opt.value, currentSelection);
      });
    });
  }

  function updateAll() {
    var pickers = document.querySelectorAll('variant-selects');
    log('updateAll: found', pickers.length, 'variant-selects');
    pickers.forEach(update);
  }

  // Event delegation: catch change events anywhere in the document, find
  // the variant-selects ancestor of the target, and re-evaluate.
  // Defer with setTimeout so Dawn's own handler (which fetches the new
  // variant HTML and replaces variant-selects) runs first.
  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target) return;
    if (target.tagName !== 'INPUT' && target.tagName !== 'SELECT') return;
    var picker = target.closest('variant-selects');
    if (!picker) return;
    log('change event detected:', target.tagName, target.value);
    // Multi-pass: re-apply at 80ms, 300ms, 600ms to cover Dawn's async re-render
    setTimeout(updateAll, 80);
    setTimeout(updateAll, 300);
    setTimeout(updateAll, 600);
  }, true);

  // Global MutationObserver on body: re-apply ovunque appaia un variant-selects
  // (Dawn REPLACE l'intero <variant-selects> al cambio variante, quindi observer
  // su singolo picker viene staccato. Watching su body cattura sostituzioni).
  var bodyMO = null;
  var pendingRun = false;
  function scheduleUpdate() {
    if (pendingRun) return;
    pendingRun = true;
    requestAnimationFrame(function () {
      pendingRun = false;
      updateAll();
    });
  }
  function watchAll() {
    if (bodyMO) return;
    bodyMO = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'VARIANT-SELECTS' || n.querySelector && n.querySelector('variant-selects')) {
            log('variant-selects appeared in DOM, re-applying');
            scheduleUpdate();
            return;
          }
        }
      }
    });
    bodyMO.observe(document.body, { childList: true, subtree: true });
  }

  // Initial pass
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { updateAll(); watchAll(); });
  } else {
    updateAll();
    watchAll();
  }

  document.addEventListener('shopify:section:load', function () { updateAll(); watchAll(); });
})();
